export type PickupCorporateSpecialHandlingCode = 'DG' | 'K' | 'KAYU'

export interface PickupCorporateSpecialHandlingLabel {
  flag: 'dangerous_goods' | 'quarantine' | 'wood_packing'
  code: PickupCorporateSpecialHandlingCode
}

export interface PickupCorporateTableRow {
  shipmentId: string
  rowNumber: number
  specialHandlingLabels: PickupCorporateSpecialHandlingLabel[]
  customerName: string
  clientLabel: string
  phoneMaskedDisplay: string
  phonePlainDisplay: string | null
  isPhoneRevealed: boolean
  isPhoneRevealLoading?: boolean
  estimateKoliBeratLabel: string
  estimateScheduleDate: string
  estimateScheduleTimeRange: string
  crrnfdDate: string
  crrnfdTime: string
  nfdCount: number
  latitude: number
  longitude: number
  isAddressRevealLoading?: boolean,
  note: string,
  executionPlatform: string
}

export interface PickupCorporateTableSort {
  field: string
  direction: 'ASC' | 'DESC'
}

export function formatNFDStatusClass(count: number): string {
  if (count === 1) return 'one'
  if (count === 2) return 'two'
  if (count === 3) return 'three'
  if (count === 4) return 'four'
  if (count === 5) return 'five'
  return 'more'
}

export function mapSpecialHandlingCode(flag: string): PickupCorporateSpecialHandlingCode | '' {
  if (flag === 'dangerous_goods') return 'DG';
  if (flag === 'quarantine') return 'K';
  if (flag === 'wood_packing') return 'KAYU';
  return '';
}
